/**
 * Action creators for authentication.
 */

import actionCreatorFactory from 'typescript-fsa'
import type { FirebaseError } from 'firebase/app'
import type { User } from 'firebase/auth'

const actionCreator = actionCreatorFactory('Auth')

export interface LoginRequestPayload {
	username: string
	password: string
}
export const login = actionCreator<LoginRequestPayload>('LOGIN')
export type LoginAction = ReturnType<typeof login>

/** The user has been logged out. */
export const logout = actionCreator('LOGOUT')

export const loggedIn = actionCreator<User>('LOGGED_IN')

export const loggedOut = actionCreator('LOGGED_OUT')

export const loginError = actionCreator<FirebaseError>('LOGIN_ERROR')
